import React from 'react';
import { defaultUserPickerStyles } from '@atlassian/jira-base-user-picker/src/styled.tsx';
import GroupPickerEdit from '@atlassian/jira-issue-field-group-picker/src/ui/edit/index.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateGroupPickerField } from '../../common/utils/validators/index.tsx';
import type { FieldValue, GroupPickerFieldConfig, Props } from './types.tsx';
import { transformGroupDefaultValueToUserOption } from './utils.tsx';

const SingleGroupPickerField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange },
		fieldId,
		error,
		autoCompleteUrl,
		autoFocus = false,
		isDropdownMenuFixedAndLayered = false,
		ariaLabelledBy,
	} = props;

	const getExtraProps = () => {
		if (isDropdownMenuFixedAndLayered) {
			return {
				menuPosition: 'fixed',
				groupPickerStyles: defaultUserPickerStyles,
				onCloseMenuOnScroll: closeMenuOnScroll,
			} as const;
		}

		return { onCloseMenuOnScroll: closeMenuOnScroll };
	};

	return (
		<GroupPickerEdit
			autoCompleteUrl={autoCompleteUrl}
			onChange={onChange}
			value={value}
			fieldId={fieldId}
			autoFocus={autoFocus}
			isMulti={false}
			aria-labelledby={ariaLabelledBy}
			width={width}
			isInvalid={Boolean(error)}
			placeholder=" "
			caseInsensitiveSearch
			{...getExtraProps()}
		/>
	);
};

export default withFormField({
	validator: validateGroupPickerField,
	transformDefaultValue: transformGroupDefaultValueToUserOption,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<GroupPickerFieldConfig, LegacyValue<UserPickerOption>>, any>'.
})<GroupPickerFieldConfig, FieldValue>(SingleGroupPickerField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateSingleGroupPickerField } from './utils';
